import httpClient from "./httpClient";
import type { ApiResponse } from "../types/api";

export default class MaintenanceApi {
  static getMaintenance(): Promise<ApiResponse> {
    return httpClient.get(BACK_URL + "/maintenance/status").then((response) => response.data);
  }
}
